import { makeStyles } from '@material-ui/styles';

const MeetingItem: React.FC = ({ children }) => {
    const classes = useStyles();

    return <div className={classes.meetingItem}>{children}</div>;
};

const useStyles = makeStyles(
    theme => ({
        meetingItem: {
            padding: '24px 0',
            borderBottom: `solid 1px ${theme.customization.background.C30}`,
            '&:last-child': {
                borderBottom: 'none',
                marginBottom: 16,
            },
        },
    }),
    { classNamePrefix: 'meetings-meeting-item' }
);

export default MeetingItem;
